'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports['default'] = EnterpriseAgreementPricingSummary;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fecha = require('fecha');

var _fecha2 = _interopRequireDefault(_fecha);

var _pill = require('common/components/pill');

var _pill2 = _interopRequireDefault(_pill);

require('./enterprise-agreement-pricing-summary.scss');

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var periodShortNames = {
    month: 'mo',
    year: 'yr'
};
var cloneDate = function cloneDate(d) {
    return new Date(d.getTime());
};
var isYearlyPlan = function isYearlyPlan(periodName) {
    return periodName === 'year';
};
var isPerpetualCoupon = function isPerpetualCoupon(couponInfo) {
    return couponInfo.duration === 9999;
};

function addMonths(amount, date) {
    var d = cloneDate(date);
    d.setMonth(d.getMonth() + amount);
    return d;
}

function addDays(count, date) {
    var d = cloneDate(date);
    d.setDate(d.getDate() + count);
    return d;
}

function subtractDays(count, date) {
    var d = cloneDate(date);
    d.setDate(d.getDate() - count);
    return d;
}

/**
 * Computes the date ranges for each scenario based on the defined scenarios.
 *
 * TODO: I'd like to try and find a cleaner way to write this section of code.
 */
function computeDateRanges(now, periodName, couponInfo, isFreeTrial) {
    var freeTrialStart = void 0;
    var freeTrialEnd = void 0;
    var couponStart = void 0;
    var couponEnd = void 0;
    var listStart = void 0;

    // Pointer to the date that represents a day before the next range's start
    // date.  In each range, we compute the start date by adding one to this
    // pointer
    var nextEndDate = subtractDays(1, now);

    // Month offset is used to compute the coupon end date if applicable.
    var couponMonthOffset = 0;

    if (isFreeTrial) {

        freeTrialStart = addDays(1, nextEndDate);

        // Free trials are 30 days, but we're including the last day so we only
        // add 29
        freeTrialEnd = addDays(29, freeTrialStart);

        nextEndDate = freeTrialEnd;
    }

    if (couponInfo) {
        couponStart = addDays(1, nextEndDate);

        if (isYearlyPlan(periodName)) {
            couponMonthOffset += 12;
        } else {
            couponMonthOffset = couponInfo.duration;
        }

        couponEnd = subtractDays(1, addMonths(couponMonthOffset, couponStart));
        nextEndDate = couponEnd;
    }

    listStart = addDays(1, nextEndDate);

    return {
        freeTrialPrice: {
            start: freeTrialStart,
            end: freeTrialEnd
        },
        couponPrice: {
            start: couponStart,
            end: couponEnd
        },
        listPrice: {
            start: listStart
        }
    };
}

var formatDate = function formatDate(d) {
    return _fecha2['default'].format(d, 'MMM D, YYYY');
};
var dateRangeCopy = function dateRangeCopy(from, to) {
    return formatDate(from) + ' - ' + formatDate(to);
};

/**
 * Helper Component for displaying the rate
 */
function Rate(props) {
    var rate = props.rate;

    var _String$split = String(rate).split('.'),
        _String$split2 = _slicedToArray(_String$split, 2),
        dollars = _String$split2[0],
        cents = _String$split2[1];

    return _react2['default'].createElement(
        'div',
        { className: 'm-ent-plan-pricing-summary-rate c-castle-rock' },
        _react2['default'].createElement(
            'span',
            { className: 'm-ent-plan-pricing-summary-rate__currency' },
            '$'
        ),
        _react2['default'].createElement(
            'span',
            { className: 'm-ent-plan-pricing-summary-rate__amount' },
            dollars,
            cents && _react2['default'].createElement(
                'span',
                null,
                '.',
                cents
            )
        )
    );
}

Rate.propTypes = {
    rate: _react.PropTypes.string.isRequired,
    per: _react.PropTypes.string
};

/**
 * Helper component for displaying a pricing summary block.  Props here are
 * provided as elements or strings because they may differ depending on the
 * context.
 *
 */
function EnterprisePricingSummaryBlock(props) {
    var label = props.label,
        copy = props.copy,
        range = props.range,
        testRef = props.testRef,
        rate = props.rate,
        per = props.per,
        isPartnerPlan = props.isPartnerPlan;


    var pill = void 0;
    var rateBlock = void 0;
    if (!isPartnerPlan) {

        pill = _react2['default'].createElement(
            'div',
            { className: 'm-ent-plan-pricing-summary-block__pill' },
            _react2['default'].createElement(
                _pill2['default'],
                { velvet: true },
                label
            )
        );

        rateBlock = _react2['default'].createElement(
            'div',
            { className: 'm-ent-plan-pricing-summary-block__rate', 'data-test-ref': 'rate' },
            rate,
            per && _react2['default'].createElement(
                'span',
                { className: 'm-ent-plan-pricing-summary-block__per' },
                '/',
                per
            )
        );
    }

    return _react2['default'].createElement(
        'div',
        { className: 'm-ent-plan-pricing-summary-block border-1-warm-chinchilla c-castle-rock bg-plume', 'data-test-ref': testRef },
        pill,
        rateBlock,
        _react2['default'].createElement(
            'div',
            { className: 'm-ent-plan-pricing-summary-block__copy', 'data-test-ref': 'copy' },
            copy
        ),
        _react2['default'].createElement(
            'div',
            { className: 'm-ent-plan-pricing-summary-block__range' + (isPartnerPlan ? ' partner' : ''), 'data-test-ref': 'range' },
            range
        ),
        _react2['default'].createElement('div', { className: 'clear-both' })
    );
}

EnterprisePricingSummaryBlock.propTypes = {
    copy: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string]),
    label: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string]),
    range: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string]),
    rate: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string]),
    isPartnerPlan: _react.PropTypes.bool,
    testRef: _react.PropTypes.string
};

/**
 * Displays the pricing info to the user for enterprise agreements.  There are a
 * lot of different rendering variations depending on the coupon, free trial,
 * and billing plan period.  Please see the tests for the different scenarios.
 */
function EnterpriseAgreementPricingSummary(props) {
    var couponInfo = props.couponInfo,
        _props$now = props.now,
        now = _props$now === undefined ? new Date() : _props$now,
        discountedRate = props.discountedRate,
        periodName = props.periodName,
        totalRate = props.totalRate,
        isFreeTrial = props.isFreeTrial,
        billingType = props.billingType,
        billingMethod = props.billingMethod;

    var _computeDateRanges = computeDateRanges(now, periodName, couponInfo, isFreeTrial),
        freeTrialPrice = _computeDateRanges.freeTrialPrice,
        couponPrice = _computeDateRanges.couponPrice,
        listPrice = _computeDateRanges.listPrice;

    var shouldHideListPrice = couponInfo && isPerpetualCoupon(couponInfo);
    var isPartnerPlan = billingType === _constants2['default'].BILLING_TYPE_ALTERNATIVE_CHARGE_PARTNER;

    return _react2['default'].createElement(
        'div',
        { className: 'm-ent-plan-pricing-summary' },
        isFreeTrial && _react2['default'].createElement(EnterprisePricingSummaryBlock, {
            copy: 'For First 30 Days',
            label: 'Free Trial',
            range: dateRangeCopy(freeTrialPrice.start, freeTrialPrice.end),
            rate: _react2['default'].createElement(Rate, { rate: '0' }),
            isPartnerPlan: isPartnerPlan,
            testRef: 'free-trial-price'
        }),
        couponInfo && _react2['default'].createElement(EnterprisePricingSummaryBlock, {
            copy: _react2['default'].createElement(
                'span',
                { className: 'c-azure' },
                (isYearlyPlan(periodName) ? couponInfo.annual_percentage : couponInfo.percentage) + '% off'
            ),
            label: 'Special Offer',
            per: isYearlyPlan(periodName) && !isPerpetualCoupon(couponInfo) ? '' : periodShortNames[periodName],
            range: isPerpetualCoupon(couponInfo) ? 'Starting ' + _fecha2['default'].format(couponPrice.start, 'MMM D, YYYY') : dateRangeCopy(couponPrice.start, couponPrice.end),
            rate: _react2['default'].createElement(Rate, { rate: discountedRate }),
            isPartnerPlan: isPartnerPlan,
            testRef: 'coupon-price'
        }),
        !shouldHideListPrice && _react2['default'].createElement(EnterprisePricingSummaryBlock, {
            label: 'List Price',
            per: periodShortNames[periodName],
            range: 'Starting ' + _fecha2['default'].format(listPrice.start, 'MMM D, YYYY'),
            rate: _react2['default'].createElement(Rate, { rate: totalRate }),
            isPartnerPlan: isPartnerPlan,
            testRef: 'list-price'
        })
    );
}

EnterpriseAgreementPricingSummary.propTypes = {
    couponInfo: _react.PropTypes.shape({
        duration: _react.PropTypes.number
    }),
    isFreeTrial: _react.PropTypes.bool,

    /**
     * This is includced as a prop for ease
     * of testing, but it will default to the current date for the general case.
     */
    now: _react.PropTypes.instanceOf(Date),
    discountedRate: _react.PropTypes.string.isRequired,
    periodName: _react.PropTypes.oneOf(['month', 'year']).isRequired,
    totalRate: _react.PropTypes.string.isRequired,
    billingType: _react.PropTypes.oneOf(['S', 'AI', 'AP', 'AM']),
    billingMethod: _react.PropTypes.oneOf(['CC', 'IN'])
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/enterprise-agreement-pricing-summary.jsx
 ** module id = 1127
 ** module chunks = 0
 **/